import React, { memo } from 'react';
import { makeStyles } from "@material-ui/styles";
import i18next from "i18next";
import { renderTime } from '../../../utils';
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      padding: '10px 0',
      listStyle: 'none',
      marginBottom: '26px',
      position: 'relative',
      alignItems: 'center'
    },
    text: {
      textAlign: 'center',
      color: 'rgba(1, 1, 0, 0.3)',
      fontSize: '12px',
      marginBottom: '26px'
    },
    time: {
      position: 'absolute',
      fontSize: '11px',
      height: '16px',
      color: 'rgba(1, 1, 1, .2)',
      lineHeight: '16px',
      textAlign: 'center',
      top: '-18px',
      width: '100%'
    }
  };
});

function RetractedMessage(_ref) {
  var message = _ref.message;
  var classes = useStyles({
    bySelf: message.bySelf
  });
  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, message.bySelf ? i18next.t('You retracted a message') : message.from + i18next.t('retracted a message')), /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, renderTime(message.time)));
}

export default memo(RetractedMessage);